import { createStyles } from 'antd-style';

export const useAccountProfileSectionsStyles = createStyles(({ css }) => ({
  noBackground: css`
    && &.qol-input-view-mode .ant-select-selector {
      background-color: inherit !important;
    }
  `,
  noPadding: css`
    && &.qol-input-view-mode .ant-select-selector {
      padding: 0;
    }
  `,
}));
